import { forwardRef } from 'react';
import { Button, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import EventIcon from '@mui/icons-material/Event';

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: '#1C6BFB',
    color: theme.palette.secondaryAccent.contrastText,
    transition: theme.transitions.create('background-color'),
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: 'rgba(28,107,251,0.8)',
    },
    fontWeight: 'light',
    padding: theme.spacing(0.5, 3),
    borderRadius: theme.artistActionButtons.borderRadius,
    textTransform: 'capitalize',
    fontSize: '1rem',
    '& span': {
      textTransform: 'initial',
      display: 'flex',
    },
    '&[disabled]': {
      backgroundColor: theme.palette.secondaryAccent.extraLight,
      color: `${theme.palette.secondaryAccent.contrastText} !important`,
    },
  },
}));

export const CallToActionBlue = forwardRef((props, ref) => {
  const classes = useStyles();
  const extraClasses = Array.isArray(props.classes)
    ? props.classes
    : [props.classes];

  return (
    <Button
      startIcon={props?.iconStart ? props?.iconStart : <EventIcon />}
      ref={props.forwardedRef}
      className={[classes.button, extraClasses].join(' ')}
      onClick={(e) => props.onClickHandler?.(e)}
      disabled={props.disabled}
    >
      <Typography variant='button'>
        {props.icon && props.icon(classes.buttonIcon)}
        {props.label}
      </Typography>
    </Button>
  );
});
